import React, { useState } from "react";


const TableHead = ({ columns, handleSorting, sortColumn = "" }) => {

  const handleSortingChange = (accessor) => {
    const sortOrder =
      sortColumn.includes("asc") ? "desc" : "asc";
    handleSorting(accessor, sortOrder);
  };

  return (
    <thead>
      <tr>
        {columns.map(({ label, accessor, sortable }) => {
          const isAsc = sortColumn.includes("asc");
          const isDesc = sortColumn.includes("desc");
          const isOrdered = sortColumn.includes(accessor);
          const cl = sortable
            ? isOrdered && isAsc 
              ? "up-icon"
              : isOrdered && isDesc 
              ? "down-icon"
              : "default-icon"
            : "";
          return (
            <th
              className={cl}
              key={accessor}
              onClick={sortable ? () => handleSortingChange(accessor) : null}
            >
              {label}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
